// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"87d02571","581":"fd72a38d","714":"a784c437","821":"f08fd8b4"}[chunkId] + ".chunk.js";
};